import { useDropdownMenuAnchoredPopover } from "@ui-kit/Dropdown/DropdownMenuAnchoredPopover";
import { useCallback } from "react";
import { type ConfirmOptions, ConfirmPopoverContent } from "./ConfirmPopoverContent";

export const useMenuConfirm = () => {
	const openPopover = useDropdownMenuAnchoredPopover();

	return useCallback(
		(event: Event, options: ConfirmOptions) => {
			event.preventDefault();
			const anchor = event.currentTarget as HTMLElement;

			return new Promise<boolean>((resolve) => {
				let confirmed = false;
				openPopover({
					anchor,
					onClose: () => resolve(confirmed),
					render: ({ close, closeMenu, contentRef }) => (
						<ConfirmPopoverContent
							{...options}
							align="start"
							onCancel={close}
							onConfirm={() => {
								confirmed = true;
								close();
								closeMenu();
							}}
							ref={contentRef}
							side="right"
						/>
					),
				});
			});
		},
		[openPopover],
	);
};
